import type { Dictionary, Translation } from '@/i18n/types';

const ro = {
  search: 'Căutare',
  searchPlaceholder: 'Cuvinte din titlu sau din text',
  searchButton: 'Caută',
  period: 'Perioadă',
  periodAria: 'Filtrează după perioadă',
  reset: 'Resetează',
  moreFilters: 'Mai multe filtre',
  moreFiltersCount: 'Mai multe filtre ({{count}})',
  fewerFilters: 'Mai puține filtre',
  activeFilters: 'Filtre active',
  removeFilter: 'Elimină filtrul „{{label}}”',
  clearFilters: 'Șterge filtrele',
} as const;

const en = {
  search: 'Search',
  searchPlaceholder: 'Words from the title or the text',
  searchButton: 'Search',
  period: 'Period',
  periodAria: 'Filter by period',
  reset: 'Reset',
  moreFilters: 'More filters',
  moreFiltersCount: 'More filters ({{count}})',
  fewerFilters: 'Fewer filters',
  activeFilters: 'Active filters',
  removeFilter: 'Remove the “{{label}}” filter',
  clearFilters: 'Clear filters',
} satisfies Translation<keyof typeof ro>;

export const listingFilterPanel = { ro, en } satisfies Dictionary;

export type ListingFilterPanelKey = keyof typeof ro;
